import { render, staticRenderFns } from "./NewSynAnto.vue?vue&type=template&id=405e2120&scoped=true&"
import script from "./NewSynAnto.vue?vue&type=script&lang=js&"
export * from "./NewSynAnto.vue?vue&type=script&lang=js&"
import style0 from "./NewSynAnto.vue?vue&type=style&index=0&id=405e2120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e2120",
  null
  
)

component.options.__file = "NewSynAnto.vue"
export default component.exports